import React, { useState } from "react"
import StoreLine from "./storeLine"
import OutsideClickTrigger from "../../../helpers/components/OutsideClickTrigger"
import Emitter from "../../../helpers/emitter"
import * as EventSpace from "../../../constants/eventSpaces"
import * as Event from "../../../constants/emits"
import { InventoryServiceProxy } from "../../../data-access/InventoryServiceProxy"

const enrichStore = (store, stock) => {
  store.Stock = stock
  store.IsEligibleForPickup = store.EnableSameDayPickup && store.Stock > 0
  return store
}

const enrichStoresWithStock = async (stores, productId, endpointUrl) => {
  let stockClient = new InventoryServiceProxy.Client(endpointUrl)
  return await stockClient
    .getInventoriesWithStoreStock(productId)
    .then((stock) => stores.map((s) => enrichStore(s, stock[s.StoreId])))
    .catch(() => {
      return undefined
    })
}

const ProductStockOverlay = ({ textKeys, stores, productId, inWebStock, alwaysShowStock, endpointUrl }) => {
  const [overlayOpen, setOverlayOpen] = useState(false)
  const [stockFetched, setStockFetched] = useState(false)
  const [webStores, setWebstores] = useState(stores)
  const [pickupStores, setPickupstores] = useState([])

  const openStockOverlay = async () => {
    if (!stockFetched) {
      await enrichStoresWithStock(stores, productId, endpointUrl).then((res) => {
        if (res) {
          setStockFetched(true)
          var pickupStores = res.filter((s) => (!inWebStock && s.Stock > 0) || s.IsEligibleForPickup)
          setPickupstores(pickupStores)
          setWebstores(res.filter((s) => !pickupStores.includes(s)))
        }
      })
    }

    setOverlayOpen(true)
    if (!document.getElementsByClassName("main-body")[0].classList.contains("show-overlay")) {
      document.getElementsByClassName("main-body")[0].classList.add("show-overlay")
    }
  }

  const closeStockOverlay = () => {
    setOverlayOpen(false)
    if (document.getElementsByClassName("main-body")[0].classList.contains("show-overlay")) {
      document.getElementsByClassName("main-body")[0].classList.remove("show-overlay")
    }
  }

  const headerElement = inWebStock ? (
    <div className="stock-header">
      <h2>{textKeys.storeStockOverlayHeader}</h2>
      <p>{textKeys.storeStockOverlaySubheader}</p>
    </div>
  ) : (
    <div className="stock-header">
      <h2>{textKeys.storeStockOverlayNoStockHeader}</h2>
      <p>{textKeys.storeStockOverlayNoStockSubheader}</p>
    </div>
  )

  const pickupSectionHeader = inWebStock ? (
    <div className="store-section-header">
      {textKeys.storeStockOverlayPickupHeaderIcon && <img src={textKeys.storeStockOverlayPickupHeaderIcon}></img>}
      <div className="textside">
        <h3>{textKeys.storeStockOverlayPickupHeader}</h3>
        {textKeys.storeStockOverlayPickupSubheader && <p>{textKeys.storeStockOverlayPickupSubheader}</p>}
      </div>
    </div>
  ) : (
    <div className="store-section-header">
      {textKeys.storeStockOverlayNoPickupHeaderIcon && <img src={textKeys.storeStockOverlayNoPickupHeaderIcon}></img>}
      <div className="textside">
        <h3>{textKeys.storeStockOverlayNoPickupHeader}</h3>
        {textKeys.storeStockOverlayNoPickupSubheader && <p>{textKeys.storeStockOverlayNoPickupSubheader}</p>}
      </div>
    </div>
  )

  const webSectionHeader = inWebStock ? (
    <div className="store-section-header">
      {textKeys.storeStockOverlayWebHeaderIcon && <img src={textKeys.storeStockOverlayWebHeaderIcon}></img>}
      <div className="textside">
        <h3>{textKeys.storeStockOverlayWebHeader}</h3>
        {textKeys.storeStockOverlayWebSubheader && <p>{textKeys.storeStockOverlayWebSubheader}</p>}
      </div>
    </div>
  ) : (
    <div className="store-section-header">
      {textKeys.storeStockOverlayNoWebHeaderIcon && <img src={textKeys.storeStockOverlayNoWebHeaderIcon}></img>}
      <div className="textside">
        <h3>{textKeys.storeStockOverlayNoWebHeader}</h3>
        {textKeys.storeStockOverlayNoWebSubheader && <p>{textKeys.storeStockOverlayNoWebSubheader}</p>}
      </div>
    </div>
  )

  Emitter.on(Event.withEventSpace(EventSpace.PRODUCT_STOCK_OVERLAY, Event.OPEN_OVERLAY), openStockOverlay)
  Emitter.on(Event.withEventSpace(EventSpace.PRODUCT_STOCK_OVERLAY, Event.CLOSE_OVERLAY), closeStockOverlay)
  if (overlayOpen) {
    return (
      <div id="stockOverlay">
        <OutsideClickTrigger className={"container stock-overlay"} onOutsideClick={closeStockOverlay}>
          <>
            <div style={{ textAlign: "right" }}>
              <div onClick={closeStockOverlay} className="close-brands-overlay cross"></div>
            </div>
            {headerElement}
            {pickupStores && pickupStores.length > 0 && (
              <div className="pickup-stores">
                {pickupSectionHeader}
                {pickupStores.map((s) => (
                  <StoreLine key={s.StoreId} store={s} textKeys={textKeys} availableOnWeb={inWebStock} alwaysShowStock={alwaysShowStock} />
                ))}
              </div>
            )}
            {webStores && webStores.length > 0 && (
              <div className="web-stores">
                {webSectionHeader}
                {webStores.map((s) => (
                  <StoreLine key={s.StoreId} store={s} textKeys={textKeys} availableOnWeb={inWebStock} alwaysShowStock={alwaysShowStock} />
                ))}
              </div>
            )}
          </>
        </OutsideClickTrigger>
      </div>
    )
  } else {
    return null
  }
}

export default ProductStockOverlay
